<div>
  @for(item of items(); track item) {
    <span></span>
  }
</div>
